export const URL_TOP = "/printer-management";
export const URL_PRINTERS = URL_TOP + "/printers";
export const URL_LOCATIONS = URL_TOP + "/locations";
export const URL_CUPS_OVERVIEW = URL_TOP + "/cups-job-overview";
